import QueryGuard from './QueryGuard';

export default QueryGuard;
